<template>
  <div class="app">
    <Header />
    <router-view></router-view>
  </div>
</template>

<script>
import Header from "./assets/layout/Header.vue";
export default {
  name: "app",
  components: { Header },
  watch: {
    $route: {
      immediate: true,
      handler(to) {
        document.title = to.meta.title || "Midgrab Savings Calculator";
      }
    }
  }
};
</script>

<style>
@font-face {
  font-family: "Nunito";
  src: url("./assets/fonts/nunitosans-regular-webfont.woff") format("woff");
}

* {
  font-family: "Nunito", Arial, sans-serif;
}

html,
body {
  background-color: #000000;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
